import React from 'react';
import { HeroSectionDemo } from '@/components/blocks/hero-section-demo';

const Home = () => {
  return (
    <div className="min-h-screen bg-background">
      <HeroSectionDemo />
    </div>
  );
};

export default Home; 